package com.wintermar.inspection.core.ui.component.location

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.location.util.LocationModel

@Composable
actual fun CurrentLocation(onClick: (LocationModel?) -> Unit) {
}